<template>
  <!-- 评价管理 -->
  <section class="viewContainer">
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick" v-show="isComment">
      <el-tab-pane label="店铺" name="1" />
      <el-tab-pane label="商品" name="2" />
      <el-tab-pane label="案例" name="3" v-if="applyBbType != 1" />
      <el-tab-pane label="设计师" name="4" v-if="applyBbType != 1" />
    </el-tabs>
    <div v-show="isComment">
      <!--列表-->
      <div class="main_container">
        <section class="model_section">
          <p class="model_top_title">评价管理</p>
          <el-button type="danger" @click="showAdd()" style="float: right;margin: 5px 10px 0 0"> 添加评价 </el-button>
        </section>
        <div class="table_container">
          <el-table :data="usersList" stripe border>
            <el-table-column label="序号" width="64" align="center">
              <template slot-scope="scope"> <span>{{ scope.$index + 1 }}</span></template>
            </el-table-column>
            <el-table-column label="用户" align="center">
              <template scope="scope">{{ scope.row.username }}</template>
            </el-table-column>
            <el-table-column label="店铺名称" align="center">
              <template scope="scope">
                <span class="spanList" :title="scope.row.goodsName">{{ scope.row.shopname }}</span>
              </template>
            </el-table-column>
            <el-table-column :label="`${activeName == 1 ? '店铺' : activeName == 2 ? '商品' : activeName == 3 ? '案例' : '设计师'}名称`" align="center" v-if="activeName != 1">
              <template scope="scope">
                <span class="spanList" :title="scope.row.shopName">{{ scope.row.businessname }}</span>
              </template>
            </el-table-column>
            <el-table-column label="评分" align="center">
              <template scope="scope">{{ scope.row.totalscore }}</template>
            </el-table-column>
            <el-table-column label="评价内容" align="center">
              <template scope="scope">
                <span class="spanList" :title="scope.row.content">{{ scope.row.content }}</span>
              </template>
            </el-table-column>
            <el-table-column label="回复数量" align="center">
              <template scope="scope">
                <span class="spanList" :title="scope.row.replyContent">{{ scope.row.replycount }}</span>
              </template>
            </el-table-column>
            <el-table-column label="评价时间" align="center">
              <template scope="scope">{{ scope.row.createtime }}</template>
            </el-table-column>
            <el-table-column label="操作" fixed="right" width="280" align="center">
              <template scope="scope">
                <span class="handle" @click="emitinfo(scope.row)"> 回复 </span>
                <span class="handle" @click="detailFun(scope.row)"> <i class="el-icon-view"></i> 查看 </span>
                <span class="handle" @click="deleteMerchant(scope.row)"> <i class="el-icon-delete"></i> 删除 </span>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="10"
            :current-page="pageIndex" :total="total" style="margin:10px 0;float:right;" />
        </div>
      </div>
    </div>

    <!--评价管理-->
    <div class="main_container" v-show="isStoreReviews">
      <section class="model_section">
        <p class="model_top_title">添加{{ activeName == 1 ? '店铺' : activeName == 1 ? '商品' : activeName == 1 ? '案例' :'设计师' }}评价</p>
        <el-button type="danger" @click="closeisAdd" style="float: right;margin: 5px 10px 0 0">返 回</el-button>
      </section>
      <el-form class="decorationDiaryDiv">
        <div style="width: 100%;display:flex;">
          <!-- <el-form-item label="品牌店铺：" style="width:50%" label-width="88px">
            <el-select filterable style="width:80%" v-model="brandStoreId" :disabled="decorationSeeDis"
              @change="determine">
              <el-option v-for="item in brandStoreArr" :key="item.id" :label="item.name" :value="item.id" />
            </el-select>
          </el-form-item> -->
          <el-form-item label="商品：" style="width:50%" label-width="88px" v-if="activeName==2">
            <el-select style="width:80%" v-model="relatedGoodsId" :disabled="decorationSeeDis">
              <el-option v-for="item in relatedGoodsArr" :key="item.id" :label="item.name" :value="item.id" />
            </el-select>
          </el-form-item>
          <el-form-item label="案例：" style="width:50%" label-width="88px" v-if="activeName==3">
            <el-select style="width:80%" v-model="caseListId" :disabled="decorationSeeDis">
              <el-option v-for="item in caseList" :key="item.id" :label="item.expName" :value="item.id" />
            </el-select>
          </el-form-item>
          <el-form-item label="设计师：" style="width:50%" label-width="88px" v-if="activeName==4">
            <el-select style="width:80%" v-model="designerListId" :disabled="decorationSeeDis">
              <el-option v-for="item in designerList" :key="item.DesignerId" :label="item.Name" :value="item.DesignerId" />
            </el-select>
          </el-form-item>
        </div>
        <el-form-item label="总体：" style="width:80%">
          <el-rate :colors="colorred" v-model="value1" :texts="texts" show-text :disabled="decorationSeeDis"
            style="font-size:30px" />
        </el-form-item>
        <el-form-item label="服务：" style="width:80%">
          <el-rate :colors="colorred" v-model="value2" :texts="texts" show-text :disabled="decorationSeeDis"
            style="font-size:30px" />
        </el-form-item>
        <el-form-item label="品质：" style="width:80%">
          <el-rate :colors="colorred" v-model="value3" :texts="texts" show-text :disabled="decorationSeeDis"
            style="font-size:30px" />
        </el-form-item>
        <div style="width: 100%;display:flex;">
          <el-checkbox-group v-model="checkId" style="height: 50px" :disabled="decorationSeeDis">
            <el-checkbox v-for="item in checkList" :label="item.labelid" :key="item.labelid">{{ item.labelname }}</el-checkbox>
          </el-checkbox-group>
        </div>
        <el-form-item style="width:88%">
          <el-input type="textarea" v-model="rContent" placeholder="纯文本框最多输入" :disabled="decorationSeeDis"
            :autosize="{ minRows: 3, maxRows: 6 }" show-word-limit maxlength="1000" />
        </el-form-item>
        <el-form-item label="上传视频：">
          <div v-if="videoSrc" class="videoClass">
            <span @click="newSeevideo(videoSrc)" class="previewingVideo">
              <img :src="videoImg" v-if="videoImg">
              <img src="../../assets/img/spfm.png" v-else>
              <div class="iconcontainer"><img src="../../assets/img/play.png" class="playIcon" /></div>
            </span>
            <img src="../../assets/img/aicon36.png" @click="delvideo()" v-if="!decorationSeeDis && videoSrc"
              class="chahao" />
          </div>
          <el-upload class="avatar-uploader-zstp" action="" accept="video/*" :before-upload="handleFile"
            v-if="!decorationSeeDis && !videoSrc">
            <el-progress type="circle" v-if="videoFlag" :percentage="videoUploadPercent" :width="80" :height="80" />
            <i v-else class="el-icon-plus avatar-uploader-icon" />
          </el-upload>
          <div style="color:#888;">视频格式仅支持: mp4. 视频大小不能超过 50MB !</div>
        </el-form-item>
        <el-form-item label="上传图片：">
          <div class="upPictures">
            <div class="multigraph" v-for="(item, index) in detailImgUrlarr" :key="index" :data-img="item">
              <el-image :src="item" fit="cover" style="width: 80px; height:80px" @click="handleClickItem"
                :preview-src-list="detailImgUrlarr" :z-index="9999" />
              <div class="chahao" @click.stop="deldetail(index)" v-if="!decorationSeeDis">
                <img src="../../assets/img/aicon36.png" />
              </div>
            </div>
            <!-- 上传图片 -->
            <el-upload action multiple v-if="flag < 15" :before-upload="beforeAvatarUpload" accept=".png, .jpg,.jpeg">
              <i class="el-icon-plus upBtn" v-if="!decorationSeeDis"></i>
            </el-upload>
            <div style="color:#888;">最多上传15张照片, 商品详情图尺寸为支持jpg、png等格式 </div>
          </div>
        </el-form-item>
        <div style="width: 100%;display:flex;">
          <el-form-item label="发布人昵称：" style="width:35%;" label-width="88px">
            <el-input v-model="PublisherNickname" placeholder="请输入发布人昵称" maxlength="15" style="width:80%;"
              :disabled="decorationSeeDis" />
            <!-- <el-button type="warning" class="publisherBtn" @click="handleAddPublisher" v-if="!decorationSeeDis"> 添加发布用户 </el-button> -->
          </el-form-item>
          <canvas id="canvasa" hidden width=1000 height=1000></canvas>
          <el-form-item label="发布人头像：" style="width:25%;" label-width="88px">
            <el-upload class="avatar-uploader" action accept=".jpg, .png" :show-file-list="false"
              :before-upload="beforeHeadImg" :disabled="decorationSeeDis">
              <img :src="pubHeadPortImg" v-if="pubHeadPortImg" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <div style="color:#888;"> 建议上传的图片必须是宽高比例为1:1 </div>
          </el-form-item>
          <el-form-item label="发布时间：" style="width:35%;" label-width="88px">
            <el-date-picker type="date" v-model="releaseTime" :editable="false" value-format="yyyy-MM-dd"
              :picker-options="pickerOptions" placeholder="选择日期" style="width:80%;cursor:pointer;"
              :disabled="decorationSeeDis" />
          </el-form-item>
          <!-- <el-form-item style="width:55%;">
          <img v-if="LogoUrl" :src="LogoUrl" class="fbrLogo"/>
          <div class="releaseName"><b>{{publisherTitle}}</b></div>
        </el-form-item> -->
        </div>
      </el-form>
      <div class="gudingdibu">
        <el-button @click="closeisAdd()">返 回</el-button>
        <el-button type="danger" @click="Submit()" v-if="!decorationSeeDis"
          :loading="loadingBut">{{ loadingButText }}</el-button>
      </div>
    </div>

    <!-- 商家回复 - 弹框 -->
    <el-dialog title="商家回复" width="30%" :visible.sync="isToExamine" center>
      <el-form>
        <el-form-item>
          <el-input type="textarea" placeholder="请输入回复内容" maxlength="100" v-model="shenmark" :rows="3" />
        </el-form-item>
      </el-form>
      <div style="padding-left:0;text-align:center">
        <el-button @click="isToExamine = false">取 消</el-button>
        <el-button type="danger" @click="endToExamine()">确定</el-button>
      </div>
    </el-dialog>

    <!-- 选择发布人 -->
    <el-dialog title="选择发布人" :visible.sync="dialogVisibledis" width="45%" center>
      <el-form style="display:flex">
        <el-form-item label="发布人手机号：" style="display:flex;width:50%;margin-right:10px">
          <el-input v-model="publisherPhone" placeholder="请输入发布人手机号"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="danger" @click="finddes()">查 询</el-button>
        </el-form-item>
      </el-form>
      <div class="disoutline">
        <p @click="handleGetdesId(item)" v-for="(item, index) in publisherArr" :key="index" class="disinline">
          <img :src="item.faceUrl" />
          <span>{{ item.nickName }}</span>
          <el-radio v-model="choiceRadioId" :label="item.id" class="elRadio">选择</el-radio>
        </p>
        <p style="text-align:center" v-show="noPublisherData">查无结果</p>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibledis = false">取 消</el-button>
        <el-button type="danger" @click="makedes()">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 播放视频 -->
    <el-dialog title='视频播放' :visible.sync="videoVisible" @close="closeVideo" width="30%" center>
      <video-player ref="videoPlayer" class="video-player vjs-custom-skin" :playsinline="true"
        :options="playerOptions" />
    </el-dialog>

    <!-- vueCropper 剪裁图片实现-->
    <el-dialog title="图片剪裁" :visible.sync="cropping" append-to-body center>
      <div class="cropper-content">
        <div class="cropper">
          <vueCropper ref="cropper" :img="option.img" :outputSize="option.size" :fixedBox="option.fixedBox"
            :outputType="option.outputType" :full="option.full" :canMove="option.canMove" :infoTrue="option.infoTrue"
            :canMoveBox="option.canMoveBox" :original="option.original" :autoCrop="option.autoCrop" :info="true"
            :fixed="option.fixed" :fixedNumber="option.fixedNumber" :centerBox="option.centerBox"
            :autoCropWidth="option.autoCropWidth" :autoCropHeight="option.autoCropHeight" />
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cropping = false">取 消</el-button>
        <el-button type="primary" @click="finish">确认</el-button>
      </div>
    </el-dialog>

    <!-- 抽屉详情 size="50%" -->
    <el-drawer :visible.sync="drawerVisible" size="700px">
      <template v-slot:title>
        <ul class="drawer_title">
          <li>评价详情</li>
        </ul>
      </template>
      <div class="drawer_div">
        <div class="comment-detail">
          <!-- 主评价 -->
          <div class="detail-item">
            <div class="user-box">
              <div>
                <div class="name">
                  <div class="name1">{{ info.username }}</div>
                  <div class="tips1" v-if="activeName == 3 && info.isownersaid == 1">业主</div>
                  <div class="tips1" v-else-if="info.isconsume==1">消费者</div>
                  <div class="tips1" v-else>游客</div>
                </div>
                <div class="star-box">
                  总体：<el-rate :value="info.population" disabled />
                  服务：<el-rate :value="info.service" disabled />
                  品质：<el-rate :value="info.quality" disabled />
                </div>
              </div>
            </div>

            <div class="content">{{ info.content }}</div>

            <!-- 主评价 图片/视频 -->
            <div class="media-box" v-if="info.video || (info.imgs && info.imgs.length)">
              <!-- <video v-if="info.video" :src="info.video.url" controls class="media"></video> -->
              <div v-if="info.video" class="videoClass1">
                <span @click="palySeevideo(baseOssUrl + info.video.filepath)" class="media">
                  <el-image :src="baseOssUrl+info.video.coverpath" class="media"></el-image>
                  <div class="iconcontainer1"><img src="../../assets/img/play.png" /></div>
                </span>
              </div>

              <el-image v-for="(img, i) in info.imgs" :key="i" :src="baseOssUrl + img.filepath" class="media"
                :preview-src-list="info.imgs.map(item => baseOssUrl + item.filepath)"
                @click="handleClickItem"></el-image>
            </div>

            <div class="time">{{ info.createtime }}</div>
          </div>

          <!-- 追评列表（严格对应接口 replys 字段） -->
          <div class="reply-box" v-if="info.replys && info.replys.length">
            <div class="reply-item" v-for="item in info.replys" :key="item.commentid">
              <div class="reply-user">{{ item.username }}</div>
              <div class="reply-content">{{ item.content }}</div>

              <!-- 追评 图片/视频 -->
              <div class="media-box" v-if="item.video || (item.imgs && item.imgs.length)">
                <div v-if="item.video" class="videoClass1">
                  <span @click="palySeevideo(baseOssUrl + item.video.filepath)" class="media">
                    <el-image :src="baseOssUrl + item.video.coverpath" class="media"></el-image>
                    <div class="iconcontainer1"><img src="../../assets/img/play.png" /></div>
                  </span>
                </div>

                <el-image v-for="(img, i) in item.imgs" :key="i" :src="baseOssUrl + img.filepath" class="media"
                  :preview-src-list="item.imgs.map(item => baseOssUrl + item.filepath)"
                  @click="handleClickItem"></el-image>
              </div>

              <div class="reply-time">{{ item.createtime }}</div>
            </div>
          </div>
        </div>

        <!-- 抽屉底部操作按钮 -->
        <div slot="footer" class="drawer-footer">
          <el-button @click="drawerVisible = false">关闭</el-button>
          <el-button type="primary" @click="emitinfo(info)">回复评价</el-button>
          <el-button type="danger" @click="deleteMerchant(info)">删除评价</el-button>
        </div>
      </div>
    </el-drawer>

    <!-- 初始化弹框 -->
    <el-dialog title="请选择店铺" :visible.sync="dialogVisibleadd" width="25%" center>
      <el-form class="findform">
        <el-form-item label="店铺名称：" style="display:flex;">
          <el-select v-model="bbid" filterable placeholder="请选择店铺" @change="changeForm">
            <el-option v-for="item in options1" :key="item.id" :value="item.id" :label="item.name" />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="danger" @click="gonext()">确定</el-button>
      </div>
    </el-dialog>

  </section>
</template>

<script>
import alertTrends from '../../common/alertTrends.js';
import { uploadOSS } from '../../utils/oss'; // oss上传
import { getOssFile, uploadVedio, userIdentity } from '../../api/newOss';
import { getEffectiveBrandBusiness } from "../../api/activityFormList";;
import { SelectDesignerList } from "../../api/api";
import { postgetlist, } from "../../api/shopWindow";
import {
  backgetlist, backgetinfo, commentdel, commentadd, labelgetlist,
  getProductReviewsSee,
  getEffectiveWG, getArticleVideoJzUser,
} from "../../api/comment";
export default {
  name: 'comments',
  mixins: [alertTrends],
  data() {
    return {
      baseOssUrl: localStorage.BaseOssUrl,
      activeName: "1",
      dialogVisibleadd: false,
      info: {},
      drawerVisible: false,// 抽屉显示隐藏
      bbid: '',  //店铺id
      applyBbName: '',  //店铺名称
      options1: [],
      detailA: {},
      show3: true, // 查询区域默认展开
      isComment: true, // 主页
      isStoreReviews: false, // 店铺详情
      commentId: "",
      mendianName: '', // 店铺名称
      tradeName: '', // 商品名称
      usersList: [],
      total: 1,
      pageIndex: 1,
      pageSize: 10,
      isToExamine: false, // 审核弹框
      shenmark: "", // 审核意见
      relatedGoodsId: "", // 商品
      relatedGoodsArr: [], // 商品list
      caseListId: "", // 案例id
      caseList: [], // 案例list
      designerListId: "", // 设计师id
      designerList: [], // 设计师list
      rContent: "", // 纯文本
      colorred: ["#F56C6C", "#F56C6C", "#F56C6C"],
      texts: ['非常不满意', '不满意', '一般', '满意', '非常满意'],
      value1: null,
      value2: null,
      value3: null,
      checkId: [], // 获取勾选中的值
      checkList: [],
      decorationSeeDis: false, // 置灰



      cropping: false, // 图片裁剪弹框
      distinguish: '', // 区分两个上传图片
      // 裁剪组件的基础配置option
      option: {
        img: '', // 裁剪图片的地址
        info: false, // 裁剪框的大小信息
        outputSize: 0.8, // 裁剪生成图片的质量
        outputType: 'jpeg', // 裁剪生成图片的格式
        canScale: true, // 图片是否允许滚轮缩放
        autoCrop: true, // 是否默认生成截图框
        autoCropWidth: 1000, // 默认生成截图框宽度
        autoCropHeight: 1000, // 默认生成截图框高度
        fixedBox: true, // 固定截图框大小 不允许改变
        fixed: true, // 是否开启截图框宽高固定比例
        fixedNumber: [1000, 1000], // 截图框的宽高比例
        full: false, // 是否输出原图比例的截图
        canMoveBox: false, // 截图框能否拖动
        original: false, // 上传图片按照原始比例渲染
        centerBox: true, // 截图框是否被限制在图片里面
        infoTrue: true, // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
      },



      detailImgUrlarr: [], // 多图集合
      flag: 0,

      brandStoreArr: [], // 品牌店铺列表
      brandStoreId: '', // 品牌店铺id

      publisherTitle: "", // 发布人名称回显
      LogoUrl: "", // 头像 - 全链接回显
      dialogVisibledis: false, // 选择发布人弹框
      publisherPhone: "", // 发布人手机号
      publisherArr: [], // 发布人列表
      choiceRadioId: "", // 发布人id
      choiceRadioName: "", // 发布人姓名
      choiceRadioHeadPortrait: "", // 发布人头像
      noPublisherData: false, // 查无结果

      PublisherNickname: "", // 发布人昵称
      pubHeadPortImg: "", // 发布人头像

      videoImg: "", // 封面图
      videoSrc: "", // 商品视频-全连接
      videoShortSrc: "", // 短连接
      videoFlag: false, // 进度条显隐
      videoUploadPercent: 0, // 圆形进度条
      videoVisible: false,
      playerOptions: {
        autoplay: false, // 如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '4:3', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [{
          // type: 'application/x-mpegURL', // 这里的种类支持很多种：基本视频格式、直播、流媒体等
          src: "" // 视频url地址
        }],
        poster: '', // 你的封面地址
        width: document.documentElement.clientWidth, //播放器宽度
        notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true // 全屏按钮
        }
      },
      releaseTime: '', // 发布时间
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },
      applyBbType: '',
      loadingBut: false,
      loadingButText: '发布评价',
    };
  },
  methods: {
      // 点击查看详情
    detailFun(row) {
      this.drawerVisible = true;
      var addParams = {
        shopId: this.bbid, // 店铺ID
        commentId: row.commentid, // 评论ID
      };
      backgetinfo(addParams).then(data => {
        this.info = data.resultObj;  //评论图片集合
      })
    },

      // 点击tab切换
    handleClick(val, event) {
      if (!this.bbid) {
        this.showAlert('请重新打开本功能，并选择一家店铺');
        return false;
      }
      // console.log(val);
      this.pageIndex = 1;
      this.activeName = val.name;
      this.init();
    },


    // 关闭el-image遮罩层
    handleClickItem() {
      this.$nextTick(() => {
        // 获取遮罩层dom
        let domImageMask = document.querySelector('.el-image-viewer__mask')
        if (!domImageMask) {
          return
        }
        domImageMask.addEventListener('click', () => {
          // 点击遮罩层时调用关闭按钮的 click 事件
          document.querySelector('.el-image-viewer__close').click()
        })
      })
    },

    // 获取评价管理列表
    init() {
      var addParams = {
        shopId: this.bbid,
        businessType: this.activeName, // 业务类型1=店铺评论 2=商品评论 3=案例评论 4=设计师评论
        page: this.pageIndex,
        size: this.pageSize
      };
      backgetlist(addParams).then(data => {
        this.usersList = data.resultObj.list;
        this.total = data.resultObj.totalcount; // 总条数
      })
        .catch(err => {
          this.usersList = [];
        });
    },
    // 获取设计师列表
    designerListFun() {
      var obj = {
        userId: localStorage.Id,
        name: '', // 设计师名称
        provinceId: 0,
        cityId: 0,
        sreachBbid: this.bbid, // 所属店铺
        isOnline: -1, // 状态
        pageIndex: 1,
        pageSize: 100
      };
      SelectDesignerList(obj).then(data => {
        if (data.ResultCode == 1) {
          this.designerList = data.ResultObj;
        } else {
          this.designerList = [];
        }
      });
    },
    // 案例列表
    caseListFun() {
      var obj = {
        userid: localStorage.Id, // 当前用户ID
        expname: '', // 案例名称
        status: 1, // 案例状态 -1=全部 0=下架 1=上架
        styleid: 0, // 装修风格ID
        experiencetypeid: -1, // 装修类型 -1=全部 0=家装 1=公装
        domainid: 0, // 户型ID
        shopid: this.bbid, // 店铺ID
        designername: '', // 设计师名称
        pageindex: 1,
        pagesize: 100,
      };
      postgetlist(obj).then(data => {
        if (data.resultCode == 1) {
          this.caseList = data.resultObj.list;
        } else {
          this.caseList = [];
        }
      });
    },
    // 添加评价
    showAdd() {
      console.log(this.activeName)
      if(this.activeName==2){//商品
        this.determine();
      } else if(this.activeName == 3){ //案例
        this.caseListFun();
      } else if (this.activeName == 4) {  //设计师
        this.designerListFun()
      }
      if (this.applyBbType) {
        this.getCommentTag(); // 获取评价标签
      }
      this.isComment = false;
      this.isStoreReviews = true; // 评价管理详情
      this.decorationSeeDis = false // 置灰
      this.brandStoreId = ''; // 品牌店铺
      this.checkList = [];
      this.commentId = "";
      this.relatedGoodsId = '';
      this.caseListId = '';
      this.designerListId = '';
      this.value1 = null;
      this.value2 = null;
      this.value3 = null;
      this.checkId = [];
      this.rContent = '';
      this.videoImg = ''; // 封面
      this.videoSrc = ''; // 视频
      this.videoShortSrc = ''; // 短
      this.detailImgUrlarr = [];
      this.flag = 0;
      this.publisherTitle = ''; // 回显发布人名称
      this.LogoUrl = ''; // 回显发布人头像

      this.PublisherNickname = ''; // 发布人昵称
      this.pubHeadPortImg = ''; // 发布人头像
      this.releaseTime = ''; // 发布时间
    },
    // 发布评价
    Submit() {
      if (this.activeName==2&&this.relatedGoodsId == '') {
        this.showAlert('请选择商品');
        return false;
      }
      if (this.activeName==3&& this.caseListId == '') {
        this.showAlert('请选择案例');
        return false;
      }
      if (this.activeName==4&& this.designerListId == '') {
        this.showAlert('请选择设计师');
        return false;
      }
      if (!this.value1) {
        this.showAlert('请总体评分');
        return false;
      }
      if (!this.value2) {
        this.showAlert('请服务评分');
        return false;
      }
      if (!this.value3) {
        this.showAlert('请品质评分');
        return false;
      }
      // if(this.publisherTitle == ''){
      //   this.showAlert('请添加 选择发布用户');
      //   return false;
      // }
      if (this.PublisherNickname == '') {
        this.showAlert('请输入发布人昵称');
        return false;
      }
      if (this.pubHeadPortImg == "") {
        this.showAlert('请上传发布人头像');
        return false;
      }
      if (this.releaseTime == '') {
        this.showAlert('请选择发布时间');
        return false;
      }
      this.addData();
    },

    addData() {
      let aaa = this.detailImgUrlarr.map(item => item.replace(localStorage.BaseOssUrl, ''));
      let videoImg = this.videoImg.replace(localStorage.BaseOssUrl, '')

      var files = [];
      const sptpjh = aaa.map(item => ({ filetype: 1, filepath: item, coverpath: '' }))
      if (this.videoShortSrc) {
        let aaa = [{ filetype: 2, filepath: this.videoShortSrc, coverpath: videoImg }];
        files = aaa.concat(sptpjh);
      } else {
        files = sptpjh;
      }

      // 调用新增接口
      var addParams = {
        operatetype: 1,//操作类型 1=评论 2=回复
        shopid: this.bbid,
        userid: 0,
        username: this.PublisherNickname,//评论用户名称
        useravatar: this.pubHeadPortImg,//评论用户头像
        businesstype: Number(this.activeName),  //业务类型1=店铺评论 2=商品评论 3=案例评论 4=设计师评论
        businessid: this.activeName == 1 ? this.bbid : this.activeName == 2 ? this.relatedGoodsId : this.activeName == 3 ? this.caseListId : this.activeName == 4 ? this.designerListId : '', //业务ID
        commentcontent: this.rContent, // 评价内容
        population: this.value1, // 总体评分
        service: this.value2, // 服务评分
        quality: this.value3, // 质量评分
        files: files,
        labels: this.checkList, //添加标签
        publishtime: this.releaseTime, // 发布时间
      };
      commentadd(addParams).then(data => {
        if (data.resultCode == 1) {
          this.showAlert(data.resultMsg, 'success');
          this.isComment = true; // 主页
          this.isStoreReviews = false; // 详情页
          this.init();

          this.loadingBut = false;

        } else {
          this.showAlert(data.resultMsg);
        }
      })
    },
    
    // 回复
    emitinfo(row) {
      this.commentId = row.commentid;
      this.detailA = row;
      this.shenmark = ""; // 清空
      this.isToExamine = true;
    },
    // 确定回复
    endToExamine() {
      if (this.shenmark == "") {
        this.showAlert('请输入回复内容');
        return false;
      }
      let detailA = this.detailA;
      var addParams = {
        operatetype: 2,
        shopid: this.bbid,
        userid: 0,
        username: this.applyBbName,
        useravatar: '',
        businesstype: this.activeName,
        businessid: detailA.businessid,
        commentcontent: this.shenmark,
        firstcommnetid: detailA.commentid,
      };
      commentadd(addParams).then(data => {
        if (data.resultCode == 1) {
          this.showAlert(data.resultMsg, 'success');
          this.isToExamine = false;
          this.init();
          if(this.drawerVisible){
            this.detailFun(this.info)
          }
        } else {
          this.showAlert(data.resultMsg);
        }
      })
    },
    // 删除
    deleteMerchant(row) {
      this.$swal({
        type: 'warning',
        text: '重要信息，你确定要删除吗？',
        showCancelButton: true,
        cancelButtonText: '取消',
        confirmButtonText: '确定',
      }).then(res => {
        if (res.value) {
          var params = {
            commentid: row.commentid,
            shopid: this.bbid,
          };
          commentdel(params).then(data => {
            if (data.resultCode == 1) {
              this.showAlert('操作成功', 'success');
              this.info = {};
              this.isToExamine = false;
              this.drawerVisible = false;
              this.init();
            }
          })
        }
      })
    },
    // 上传店铺视频
    handleFile(file) {
      if (file.size > 50 * 1024 * 1024) {
        this.showAlert('请上传小于50MB的视频');
        return false;
      }
      if (file.type.indexOf("mp4") == -1) {
        this.showAlert('请上传mp4格式的视频');
        return false;
      }
      // 正在上传视频中，请稍后再试
      this.loadingBut = true;
      this.loadingButText = '上传中...';
      this.videoFlag = true;
      this.videoUploadPercent = 0;
      this.timer = setInterval(() => {
        if (this.videoUploadPercent >= 99) {
          clearInterval();
          return;
        }
        this.videoUploadPercent += 1;
      }, 50);
      this.videoSrc = "";
      let obj = new FormData();
      //使用append方法向空的FormData对象添加字段
      obj.append('file', file);
      //上传视频获取路径
      uploadVedio(obj, 7).then(data => {
        if (data.resultCode == 1) {
          this.videoImg = localStorage.BaseOssUrl + data.resultObj.r_png; // 视频封面
          this.videoSrc = localStorage.BaseOssUrl + data.resultObj.r_m3u8; // 视频地址
          this.videoShortSrc = this.videoSrc.replace(localStorage.BaseOssUrl, '') // 切割
          this.loadingBut = false;
          this.loadingButText = '确定';
          this.videoFlag = false;
          this.videoUploadPercent = 0;
        } else if (data.resultCode in { 0: 0, 2: 2 }) {
          this.showAlert(data.resultMsg, 'error');
        } else {
          this.showAlert(data.resultMsg, 'error');
        }
      })

    },
    // 新版本上传oss预览
    newSeevideo() {
      if (this.videoSrc.indexOf("blob:") != -1) {
        window.open(this.videoSrc);
      } else {
        this.palySeevideo(this.videoSrc);
      }
    },
    // 播放视频
    palySeevideo(url) {
      this.videoVisible = true;
      this.playerOptions.sources[0].src = url;

    },
    closeVideo() {
      // this.$refs.videoPlayer.player.play() // 播放
      // this.$refs.videoPlayer.player.pause() // 暂停
      this.$refs.videoPlayer.player.pause();
    },
    // 删除视频操作
    delvideo() {
      this.$swal({
        type: "warning",
        text: "重要信息，确认删除视频吗？",
        showCancelButton: true,
        cancelButtonText: "取消",
        confirmButtonText: "确定",
      }).then((res) => {
        if (res.value) {
          this.videoImg = '';
          this.videoSrc = '';
          this.videoShortSrc = '';
        }
      }).catch(() => {
        return;
      });
    },
    // 多图上传
    beforeAvatarUpload(file) {
      // 判断图片格式
      const isJPG = file.type === 'image/png' || file.type === 'image/jpg' || file.type === 'image/jpeg';
      // 判断图片大小
      const isLt2M = file.size / 1024 / 1024 <= 1;
      if (!isJPG) {
        this.showAlert('上传图片只支持jpg、png等格式!');
        return;
      }
      if (!isLt2M) {
        this.showAlert('上传图片大小不能超过 1MB!');
        return;
      }
      this.flag += 1;
      if (this.flag > 15) {
        this.showAlert('最多传入15张图片');
        return false;
      }
      var _this = this;
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function (e) {
        // oss 直传图片
        let obj = { type: 26 };
        getOssFile(obj).then(data => {
          if (data.resultCode == 1) {
            let ossId = data.resultObj.accesskeyid; // 登录RAM账户id
            let ossSecret = data.resultObj.accesskeysecret; // 登录RAM账户密码
            let ossHost = data.resultObj.hostendpoint; // 请求的OSS服务端点
            let ossfile = data.resultObj.directory; // 保存路径
            let ossbucket = data.resultObj.bucket; // bucket
            localStorage.setItem('keyossId', ossId);
            localStorage.setItem('keyossSecret', ossSecret);
            localStorage.setItem('keyossHost', ossHost);
            localStorage.setItem('keyossfile', ossfile);
            localStorage.setItem('keyossbucket', ossbucket);

            uploadOSS(file, 0).then(data => {
              var newOssPic = data;
              // _this.detailImgUrlarr.push({picUrl:newOssPic})
              _this.detailImgUrlarr.push(newOssPic);
            })

          }
        })
      };
    },
    // 删除上传图片
    deldetail(val) {
      let newdetailImgUrlarr = this.detailImgUrlarr;
      for (var i = 0; i < newdetailImgUrlarr.length; i++) {
        if (val == i) {
          newdetailImgUrlarr.splice(i, 1);
        }
      }
      this.detailImgUrlarr = newdetailImgUrlarr;
      this.flag = this.detailImgUrlarr.length;
    },



    // 点击裁剪，这一步是可以拿到处理后的地址
    finish() {
      let that = this
      this.$refs.cropper.getCropBlob(data => {
        var canvas = document.getElementById("canvasa");
        var ctx = canvas.getContext("2d");
        let _URL = window.URL || window.webkitURL;
        var img = new Image();
        img.onload = start;
        img.src = _URL.createObjectURL(data);
        function start() {
          canvas.width = 1000;
          canvas.height = 1000;
          var w = img.width;
          var h = img.height;
          var sizer = Math.min((canvas.width / w), (canvas.height / h));
          ctx.drawImage(img, 0, 0, w, h, 0, 0, w * sizer, h * sizer);
          var dataURL = canvas.toDataURL('image/png');
          var getRes = dataURL;//读取的结果在result中
          function dataURLtoFile(dataurl, filename) {
            var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
              bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
            while (n--) {
              u8arr[n] = bstr.charCodeAt(n);
            }
            return new File([u8arr], filename, { type: mime });
          }
          var file = dataURLtoFile(getRes)
          that.beforeHeadImg(file)
        }
      })
    },

    // 上传发布人头像
    beforeHeadImg(file) {
      const isSize = new Promise(function (resolve, reject) {
        let _URL = window.URL || window.webkitURL;
        let img = new Image();
        img.src = _URL.createObjectURL(file);
        img.onload = function () {
          // let valid = img.width == width && img.height == height;
          let valid = img.width / img.height == 1; // 控制传正方形图片
          valid ? resolve() : reject();
        };
      })
      isSize.then(() => {
        var that = this;
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = async function (e) {
          /* oss 直传图片 */
          var obj = {
            type: 26
          };
          getOssFile(obj).then(data => {
            if (data.resultCode == 1) {
              let ossId = data.resultObj.accesskeyid; // 登录RAM账户id
              let ossSecret = data.resultObj.accesskeysecret; // 登录RAM账户密码
              let ossHost = data.resultObj.hostendpoint; // 请求的OSS服务端点
              let ossfile = data.resultObj.directory; // 保存路径
              let ossbucket = data.resultObj.bucket; // bucket
              localStorage.setItem('keyossId', ossId);
              localStorage.setItem('keyossSecret', ossSecret);
              localStorage.setItem('keyossHost', ossHost);
              localStorage.setItem('keyossfile', ossfile);
              localStorage.setItem('keyossbucket', ossbucket);

            }
          })
          var newOssPic = await uploadOSS(file, 0);
          that.pubHeadPortImg = newOssPic;
          that.cropping = false; // 图片裁剪弹框
          // that.pubHeadPortImg = newOssPic.replace(localStorage.BaseOssUrl,'')

        };
      }).catch(() => {
        // this.showAlert('上传的图片必须是宽高比例为1:1');

        var that = this;
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function (e) {
          // 上传成功后将图片地址赋值给裁剪框显示图片
          that.$nextTick(() => {
            that.option.img = e.target.result
            that.cropping = true; // 图片裁剪弹框
            setTimeout(() => {
              // document.querySelector('.crop-info').setHTML("1080 x 607")
              document.querySelector('.crop-info').innerHTML = '1000 x 1000'
            }, 300)
          })
          return
        };
        // this.showAlert('上传图片宽度应为1080px, 高度不小于607px');

      });
    },
    // 查询品牌店铺
    queryBrand() {
      var obj = {
        userId: localStorage.Id, // 登陆人id（新增）
      };
      getEffectiveBrandBusiness(obj).then(data => {
        if (data.resultCode == 1) {
          if (data.resultObj.length > 1) {
            this.brandStoreArr = data.resultObj;
          } else {
            this.brandStoreArr = data.resultObj; // 先赋值
            this.brandStoreId = data.resultObj[0].id; // 店铺id
            this.determine(this.brandStoreId);
          }
        } else {
          this.brandStoreArr = [];
        }
      });
    },
    // 确定选择品牌店铺 并查询获取关联商品
    determine(val) {
      // 获取关联商品 品类品牌
      var obj = {
        id: this.bbid
      };
      getEffectiveWG(obj).then(data => {
        if (data.resultCode == 1) {
          this.relatedGoodsArr = data.resultObj;
        } else {
          this.relatedGoodsArr = [];
        }
      });
    },
    // 评价标签
    getCommentTag() {
      var obj = {
        shopId: this.bbid,
        businessType: this.activeName
      };
      labelgetlist(obj).then(data => {
        if (data.resultCode == 1) {
          this.checkList = data.resultObj.labels;
        }
      });
    },
    // 点击选择发布人
    handleAddPublisher() {
      this.publisherPhone = "";
      this.choiceRadioId = "";
      this.dialogVisibledis = true;
      this.finddes();
    },
    // 查询发布人
    finddes() {
      var obj = {
        key: this.publisherPhone // 发布人手机号
      };
      getArticleVideoJzUser(obj).then(data => {
        if (data) {
          if (data.resultCode == 1) {
            this.publisherArr = data.resultObj;
            this.noPublisherData = false;
          } else {
            this.publisherArr = [];
            this.noPublisherData = true;
          }
        } else {
          this.publisherArr = [];
          this.noPublisherData = true;
        }
      });
    },
    // 选中发布人区域
    handleGetdesId(val) {
      this.choiceRadioId = val.id; // 获取发布人id
      this.choiceRadioName = val.nickName; // 获取发布人姓名
      this.choiceRadioHeadPortrait = val.faceUrl; // 获取发布人头像
    },
    // 确定选择发布人
    makedes() {
      if (this.choiceRadioId == "") {
        this.showAlert('请选择设计师');
        return false;
      }
      this.dialogVisibledis = false;
      this.publisherTitle = this.choiceRadioName; // 赋值发布人名称
      this.LogoUrl = this.choiceRadioHeadPortrait; // 赋值发布人头像
    },
    // 返回
    closeisAdd() {
      this.isComment = true;
      this.isStoreReviews = false; // 评价管理详情
    },
    // 分页
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.init();
    },
    // 查询
    chanxun() {
      this.pageIndex = 1;
      this.init();
    },
    // 重置
    fnReset() {
      this.mendianName = '' // 店铺名称
      this.tradeName = "" // 商品名称
    },

    changeForm(val){
      this.options1.filter((item, index) => {
        if (item.id == val) {
          this.applyBbType = item.shopType;
          this.applyBbName = item.name;
        }
      })
    },
    // 商家联盟获取用户身份以及可查看的店铺
    tankuang() {
      let addParams = {
        userId: localStorage.Id, // 当前登陆人id
      };
      userIdentity(addParams).then(data => {
        if (data) {
          if (data.resultCode == 1) {
            if (this.bbid) {
              this.gonext();
            } else {
              if (data.resultObj.length > 1) {
                // this.bbid = data.resultObj[0].id; // 店铺id
                // this.gonext();
                this.dialogVisibleadd = true;
                this.options1 = data.resultObj;
              } else { // 默认选中第一个店铺不显示弹框
                this.dialogVisibleadd = false;
                this.bbid = data.resultObj[0].id; // 店铺id
                this.applyBbType = data.resultObj[0].shopType;
                this.gonext();
              }
            }
          }
        }
      })
    },
    gonext() {
      console.log(this.bbid)
      if (!this.bbid) {
        this.showAlert('请选择店铺名称');
        return false
      }
      this.pageIndex = 1;
      this.init();
      this.dialogVisibleadd = false;
    },

  },
  mounted() {
    this.bbid = this.$route.query.shopid; // 店铺id
    this.tankuang(); // 商家联盟获取用户身份以及可查看的店铺
  }
};
</script>
<style>
.el-drawer__body {
  overflow: scroll;
}

.el-drawer__header {
  margin-bottom: 15px;
}
</style>
<style scoped lang="less">
.comment .toolbar {
  height: auto;
}

.ban_tab {
  box-shadow: 0 0 0 0;
  width: 100%;
  margin: 0 auto;
}

/* 表格操作 */
.ban_tab .comment_edit {
  float: left;
  color: #677c9d;
  width: 30%;
  margin-left: 35%;
  color: #677c9d;
  cursor: pointer;
}

/* 编辑页面 */
.add_comment {
  background-color: #ffffff;
  box-shadow: 0px 1px 10px 0px rgba(14, 5, 10, 0.1);
  margin-top: 20px;
  overflow: hidden;
  zoom: 1;
  position: relative;
}

.add_comment .el-col-24 {
  border-bottom: 1px solid #eee;
  margin-bottom: 20px;
}

/* 详情页 */
.decorationDiaryDiv {
  width: 95%;
  margin: 20px auto;
}

/* 多图 */
.upPictures {
  width: 88%;
  margin-top: 10px;
}

.multigraph {
  width: 80px;
  height: 80px;
  position: relative;
  float: left;
  margin-right: 10px;
  margin-top: 5px;
  margin-bottom: 5px;
}

.chahao {
  width: 18px;
  height: 18px;
  text-align: center;
  line-height: 25px;
  color: #666;
  position: absolute;
  right: -8px;
  top: -8px;
  cursor: pointer;
}

.upBtn {
  width: 80px;
  height: 80px;
  line-height: 80px;
  border: 1px solid #DCDFE6;
  font-size: 26px;
  color: #999;
  margin-top: 5px;
}

/* 添加发布用户-按钮 */
.publisherBtn {
  height: 36px;
  line-height: 0;
  display: inline-block;
  font-weight: bold;
  text-align: center;
  cursor: pointer;
  margin-top: 5px;
  margin-right: 20px;
}

.fbrLogo {
  width: 10%;
  border-radius: 10%;
}

.releaseName {
  width: 10%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  text-align: center;
  color: #888;
  line-height: 22px;
  margin-top: 10px;
}

/* 发布人信息 */
.disoutline {
  max-height: 260px;
  height: auto;
  overflow: auto;
  border: 1px solid #eee;
  padding: 0 15px 0 15px;
}

.disinline {
  position: relative;
  height: auto;
  border-bottom: 1px solid #eee;
  padding-bottom: 10px;
  cursor: pointer;
}

.disinline>img {
  width: 50px;
  height: 50px;
  cursor: pointer;
}

.disinline>span {
  margin-left: 10px;
  cursor: pointer;
}

.elRadio {
  position: absolute;
  top: 15px;
  right: 0px;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 80px;
  height: 80px;
  line-height: 80px;
  text-align: center;
  border: 1px solid #eeeeee;
  margin-top: 10px;
}

.avatar {
  width: 80px;
  height: 80px;
  display: block;
}

/* 图片预览弹窗样式优化 */
::v-deep .el-image-viewer__wrapper {
  z-index: 9999 !important;
}

::v-deep .el-image-viewer__canvas {
  display: flex;
  justify-content: center;
  align-items: center;
}

::v-deep .el-image-viewer__img {
  max-height: 90vh !important;
  max-width: 90vw !important;
}




.comment-detail {
  padding: 10px;
}

.detail-item {
  background: #f5f5f5;
  padding: 15px;
  border-radius: 8px;
  margin-bottom: 20px;
}

.user-box {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 15px;
}

.name {
  display: flex;
}
.name1{
  font-size: 14px;
  color: #888;
}
.tips1{
  width: auto;
  height: 16px;
  line-height: 16px;
  padding: 0 8px;
  font-size: 10px;
  text-align: center;
  margin-left: 10px;
  color: #fff;
  background: #FF7E32;
  border-radius: 0px 8px 0px 8px;
}

.star-box {
  margin-top: 5px;
  display: flex;
  gap: 8px;
  align-items: center;
  color: #333;
}

.content {
  font-size: 14px;
  line-height: 1.6;
  margin: 10px 0;
  color: #333;
}

/* 统一图片视频样式 */
.media-box {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin: 10px 0;
}

.media {
  width: 120px;
  height: 120px;
  border-radius: 4px;
  object-fit: cover;
}
.videoClass1{
  width: 120px;
  height: 120px;
  border-radius: 4px;
  object-fit: cover;
  position: relative;
}
.iconcontainer1{
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  position: absolute;
  top: 0;
  left: 0;
}
.iconcontainer1>img{
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 40px;
  height: 40px;
}

.time {
  font-size: 12px;
  color: #999;
}

/* 追评样式 */
.reply-item {
  padding: 12px;
  border-radius: 6px;
  margin-bottom: 10px;
}

.reply-user {
  font-weight: 500;
  margin-bottom: 5px;
}

.reply-content {
  font-size: 13px;
  color: #333;
  word-break: break-all;
  word-wrap: break-word;
}

.reply-time {
  font-size: 12px;
  color: #999;
  margin-top: 5px;
}

</style>


// WEBPACK FOOTER //
// comments.vue?71b584a4